import GroupingsDataViewer from "./GroupingsDataViewer.js";
const install = molten => {
  // simple test
  molten.addPlugin('DataViewer', GroupingsDataViewer);
};
export default {
  install
};